import { createStore, applyMiddleware, compose } from "redux";
import createSagaMiddleware from "redux-saga";
import { rootSaga } from "../sagas";
import { rootReducer } from "../reducers";
import storage from "redux-persist/lib/storage";
import { persistStore, persistReducer } from "redux-persist";
import { injectStoreIdentifier } from "../util/identifier";
import { injectStoreGeneral } from "../util/general";
import { injectStoreApi } from "../util/api";
import { injectDepsAuthFailure } from "../util/authFailure";
import { parse, stringify } from "flatted";

// Detect only true parent-chain cycles (A -> ... -> A).
// Reused/shared object references in different branches are allowed.
function isCyclic(obj) {
  const visited = new WeakSet();
  const inPath = new WeakSet();

  function detect(value) {
    if (!value || typeof value !== "object") {
      return false;
    }

    if (inPath.has(value)) {
      return true;
    }

    if (visited.has(value)) {
      return false;
    }

    visited.add(value);
    inPath.add(value);

    const keys = Object.keys(value);
    for (const key of keys) {
      if (detect(value[key])) {
        return true;
      }
    }

    inPath.delete(value);
    return false;
  }

  return detect(obj);
}

const persistConfig = {
  key: "root",
  storage,
  serialize: stringify,
  deserialize: parse,
};

const sagaMiddleware = createSagaMiddleware();
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = createStore(
  persistedReducer,
  composeEnhancers(applyMiddleware(sagaMiddleware)),
);

injectStoreIdentifier(store);
injectStoreGeneral(store);
injectStoreApi(store);

// Check for cyclic structures
store.subscribe(() => {
  const state = store.getState();
  if (isCyclic(state)) {
    console.error("Cyclic structure detected in state:", state);
  }
});

for (let a = 0; a <= 30; a++) {
  // console.log('*');
}

// console.log('initial state: ', JSON.stringify(store.getState()));

export const persistor = persistStore(store);

injectDepsAuthFailure({ persistor, store });

sagaMiddleware.run(rootSaga);

export const action = (type) => store.dispatch({ type });

// Uncomment to purge all redux state
// persistor.purge();
